module.exports = {
      id: "comments-outline-usage",
      viewBox: "0 0 32 36",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#comments-outline",
      toString: function () {
        return this.url;
      }
    }